import { DataGrid } from "@material-ui/data-grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router";
import { Toolbar, Typography, Input } from "@material-ui/core";
import { listBlockedUsers } from "../../sdk/users";
import { AdminUserInfo } from "../../../../../services/user-admin/types/api/user-info";

const getPage = (
  next: string | undefined,
  setLoading: (loading: boolean) => void,
  setPage: (page: AdminUserInfo[]) => void,
  setSize: (size: number) => void,
  setNext: (next?: string) => void
) => {
  setLoading(true);
  listBlockedUsers(next)
    .then((data) => {
      setPage(data.users);
      setSize(0);
      setNext(data.next);
    })
    .finally(() => setLoading(false));
};

export const UsersListPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState(0);
  const [page, setPage] = React.useState<AdminUserInfo[]>([]);
  const [, setNext] = React.useState<string>();
  const [userName, setUserName] = React.useState("");

  React.useEffect(() => {
    getPage(undefined, setLoading, setPage, setSize, setNext);
  }, []);

  const gotoDetail = () => history.push(`${location.pathname}/${userName}`, location.state);

  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Users
        </Typography>
        <Input
          placeholder="Lookup user"
          inputProps={{ "aria-label": "search" }}
          style={{ width: "300px" }}
          value={userName}
          onChange={(ev) => setUserName(ev.target.value)}
          onKeyDown={(ev) => (ev.key === "Enter" ? gotoDetail() : undefined)}
        />
      </Toolbar>
      <Typography variant="h6" style={{ flexGrow: 1, marginTop: "20px" }}>
        Blocked Users:
      </Typography>
      <div style={{ display: "flex", height: "600px", marginTop: "20px" }}>
        <DataGrid
          rows={page}
          columns={[
            {
              field: "name",
              headerName: "Name",
              width: 300,
              valueFormatter: (params) =>
                [params.row.givenName, params.row.familyName]
                  .filter((e) => !!e)
                  .join(" "),
            },
            { field: "email", headerName: "Email", width: 300 },
            { field: "telephone", headerName: "Telephone", width: 300 },
          ]}
          pagination
          pageSize={10}
          rowCount={size}
          paginationMode="server"
          loading={loading}
          onRowClick={(params, ev) => {
            const url = `${location.pathname}/${params.row.id}`;
            if (ev.ctrlKey || ev.metaKey) {
              window.open(url, '_blank')
            } else {
              history.push(url, location.state)
            }
          }}
        />
      </div>
    </section>
  );
};
